import React, { useState, useRef, TouchEvent } from 'react';
import { images } from '../../assets';
import './HowYouFeel.css';
import FadeInSection from '../FadeInSection/FadeInSection';

const HowYouFeel: React.FC = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleTouchStart = (e: TouchEvent) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - (containerRef.current?.offsetLeft || 0));
    setScrollLeft(containerRef.current?.scrollLeft || 0);
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX - (containerRef.current?.offsetLeft || 0);
    const walk = (x - startX) * 2;
    if (containerRef.current) {
      containerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <section className="how-you-feel-section">
      <div className="how-you-feel-content">
        <FadeInSection>
          <h2 className="how-you-feel-title">
          Designed for your health & well-being
          </h2>
        </FadeInSection>
        <FadeInSection delay={600}>
          <p className="how-you-feel-description">
          By consistently elevating your Heart Rate Variability (HRV), you are reducing the chronic inflammation that damages DNA. 
          </p>
        </FadeInSection>
        <div 
          className="how-you-feel-image-container"
          ref={containerRef}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <img 
            src={images.howYouFeel} 
            alt="How You Feel" 
            className="how-you-feel-image"
          />
        </div>
      </div>
    </section>
  );
};

export default HowYouFeel; 